import { render, staticRenderFns } from "./SroSettings.vue?vue&type=template&id=22ab634f&"
import script from "./SroSettings.vue?vue&type=script&lang=js&"
export * from "./SroSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports